import * as users from 'src/api/users'
import router from 'src/router'
import {
  GET_USER
} from 'src/store/mutation-types'

const getUser = ({commit, dispatch}, configs) => {
  dispatch('toggleLoadding', true, {root: true})
  users.getUser(configs.id, configs.params).then(response => {
    switch (response.code) {
      case 200:
        dispatch('toggleLoadding', false, {root: true})
        commit(GET_USER, response.data)
        break
      case 404:
        dispatch('toggleLoadding', false, {root: true})
        dispatch('showNotify', {
          title: 'Không tìm thấy tài nguyên',
          body: 'User không tồn tại trên hệ thống',
          type: 'warning'
        }, {root: true})
        router.push({name: 'user'})
        break
      default:
        dispatch('toggleLoadding', false, {root: true})
    }
  })
}

export default {
  getUser
}



// WEBPACK FOOTER //
// ./src/components/user/store/actions.js